import { render, staticRenderFns } from "./SalesComparisonChart.vue?vue&type=template&id=099a8440&scoped=true"
import script from "./SalesComparisonChart.vue?vue&type=script&lang=js"
export * from "./SalesComparisonChart.vue?vue&type=script&lang=js"
import style0 from "./SalesComparisonChart.vue?vue&type=style&index=0&id=099a8440&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099a8440",
  null
  
)

export default component.exports